const doc = [({"en":({"js":({"nemoa":({"activities":({"required_metadata_proxy_with_surveys":({"save_and_continue_registration":"Save and continue registration"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;